import React, { lazy } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

import { DependentsLayout } from 'pages/dependents/DependentsLayout';
import { FormRequestLayout } from 'pages/formRequest/FormRequestLayout';
import { RecordRequestLayout } from 'pages/recordRequest/RecordRequestLayout';
import { FavoriteProviders } from 'pages/favoriteProviders/favoriteProviders.module';

import { SuspenseWrapper } from 'components/containers';
import { ErrorTest } from 'pages/errorTest/ErrorTest'

const DashboardLazy = lazy(() =>
  import(/* webpackChunkName: "dashboard" */ 'pages').then(({ Dashboard }) => ({
    default: Dashboard,
  })),
);

const DependentsLazy = lazy(() =>
  import(/* webpackChunkName: "dependents" */ 'pages').then(({ Dependents }) => ({
    default: Dependents,
  })),
);

const CreateDependentLazy = lazy(() =>
  import(/* webpackChunkName: "create-dependent" */ 'pages').then(({ AddDependent }) => ({
    default: AddDependent,
  })),
);

const SupportLazy = lazy(() =>
  import(/* webpackChunkName: "support" */ 'pages').then(({ Support }) => ({
    default: Support,
  })),
);

const RefundRequestLazy = lazy(() =>
  import(/* webpackChunkName: "refund-request" */ 'pages').then(({ RequestRefund }) => ({
    default: RequestRefund,
  })),
);

const ProfileLazy = lazy(() =>
  import(/* webpackChunkName: "profile" */ 'pages').then(({ Profile }) => ({
    default: Profile,
  })),
);

const SubscriptionLazy = lazy(() =>
  import(/* webpackChunkName: "profile" */ 'pages').then(({ SubscriptionRouter }) => ({
    default: SubscriptionRouter,
  })),
);

const FormsAndRecordsLazy = lazy(() =>
  import(/* webpackChunkName: "forms-and-records" */ 'pages').then(({ FormsAndRecords }) => ({
    default: FormsAndRecords,
  })),
);

const RequestDetailLazy = lazy(() =>
  import(/* webpackChunkName: "request-detail" */ 'pages').then(({ RequestDetail }) => ({
    default: RequestDetail,
  })),
);

const RequestStatusLazy = lazy(() =>
  import(/* webpackChunkName: "request-detail" */ 'pages').then(({ RequestStatus }) => ({
    default: RequestStatus,
  })),
);

const ProviderLazy = lazy(() =>
  import(/* webpackChunkName: "request-detail" */ 'pages').then(({ Provider }) => ({
    default: Provider,
  })),
);

const MedicalRecordUploadLazy = lazy(() =>
  import('pages/provider/medical_records').then(({ MedicalRecordsMain }) => ({
    default: MedicalRecordsMain,
  })),
);


export const AppRouter = () => (
  <Switch>
    <Route path="/dashboard">
      <SuspenseWrapper>
        <DashboardLazy />
      </SuspenseWrapper>
    </Route>
    <Route path="/dependents/add">
      <SuspenseWrapper>
        <CreateDependentLazy />
      </SuspenseWrapper>
    </Route>
    <Route path="/dependents/:id">
      <SuspenseWrapper>
        <DependentsLayout />
      </SuspenseWrapper>
    </Route>
    <Route path="/dependents">
      <SuspenseWrapper>
        <DependentsLazy />
      </SuspenseWrapper>
    </Route>
    <Route path="/form-request">
      <SuspenseWrapper>
        <FormRequestLayout />
      </SuspenseWrapper>
    </Route>
    <Route path="/record-request">
      <SuspenseWrapper>
        <RecordRequestLayout />
      </SuspenseWrapper>
    </Route>
    <Route path="/request-status">
      <SuspenseWrapper>
        <RequestStatusLazy />
      </SuspenseWrapper>
    </Route>
    <Route path="/support">
      <SuspenseWrapper>
        <SupportLazy />
      </SuspenseWrapper>
    </Route>
    <Route path="/request-refund">
      <SuspenseWrapper>
        <RefundRequestLazy />
      </SuspenseWrapper>
    </Route>
    <Route path="/profile">
      <SuspenseWrapper>
        <ProfileLazy />
      </SuspenseWrapper>
    </Route>
    <Route path="/subscription">
      <SuspenseWrapper>
        <SubscriptionLazy />
      </SuspenseWrapper>
    </Route>
    <Route path="/records-and-forms">
      <SuspenseWrapper>
        <FormsAndRecordsLazy />
      </SuspenseWrapper>
    </Route>
    <Route path="/request-detail/:rid">
      <SuspenseWrapper>
        <RequestDetailLazy />
      </SuspenseWrapper>
    </Route>
    <Route path="/l/:urlId/medical-records">
      <SuspenseWrapper>
        <MedicalRecordUploadLazy />
      </SuspenseWrapper>
    </Route>
    <Route path="/favorites-providers">
      <SuspenseWrapper>
        <FavoriteProviders />
      </SuspenseWrapper>
    </Route>
    <Route path="/l/:urlId">
      <SuspenseWrapper>
        <ProviderLazy />
      </SuspenseWrapper>
    </Route>
    
    <Redirect to="/dashboard" />
  </Switch>
);
